import React from "react";
import t from '../../../helpers/t';
import { CenterDiv } from "../styled_components/divs";
import Biscuit from '../../../../utils/Biscuit';
const AddPriceButton = (props) => {

  const onButtonClicked = (e) => {
            props.onAddPriceClicked(e);
        };

  return (
    <>
        <CenterDiv className="row medium-12 small-12" style={{paddingTop:"20px"}}>
            <a
                href="#"
                id="inb-c-left-bar-add-resource"
                onClick={e => props.onSave(e)}
                className={"button beautify beautify-" + Biscuit.get('user.client_id')}
            >
                <i className="fi fi-check"></i>
                <span>{t('save')}</span>
            </a>
            {props.addPriceVisible && <><a
          href="#"
          id="inb-c-left-bar-add-resource"
          onClick={e => onButtonClicked(e)}
          className={"button beautify beautify-" + Biscuit.get('user.client_id')}
          style={{marginLeft:"5px"}}
      >
          <i className="fi fi-page-add"></i>
          <span>
              {t('add_${a}',{a:t('price',null, 'capital')})}
          </span>
      </a></>}
        </CenterDiv>
    </>
  );
};
export default AddPriceButton;